import api from "services/api"

export const createCompany = async (params: any
) => {
    const response = await api.post("/crud/Fabrica", params).then((response) => {
        return response.data
    }).catch((error) => {
        ErrorUnknown(error)
    })
    return response
}

const ErrorUnknown = (error: any) => {
    throw {
        response: {
            data: {
                message: error.message === "Network Error" ?
                    "Erro inesperado! Entre em contato com a equipe de desenvolvimento."
                    : error.response.data.message
            }
        }
    }
}